import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { InfoIdentidad } from '../../../../models/info-Identidad';
import { InfoIdentidadService } from '../../../../services/info-identidad.service';
import { InfoIdentidadDetalleComponent } from '../info-identidad-detalle/info-identidad-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-info-identidad-cab',
  templateUrl: './info-identidad-cab.component.html',
  styleUrls: ['./info-identidad-cab.component.css']
})
export class InfoIdentidadCabComponent implements OnInit {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  infoIdentidad: InfoIdentidad;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  infoIdentidadHistoryList: any;
  infoIdentidadesList: InfoIdentidad[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  infoIdentidades: InfoIdentidad[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  identidadesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildInfoIdentidadDetalle') infoIdentidadDetalle: InfoIdentidadDetalleComponent;

  constructor(private infoIdentidadService: InfoIdentidadService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerIdentidades(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Info Identidad")) this.permisoEdicion = true;
  }

  obtenerIdentidades(agrupar)
  {
    this.buscando = true;
    this.infoIdentidadService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaEmision = this.momentService.convertDateServer(currentValue.fechaEmision);
          currentValue.fechaValidez = this.momentService.convertDateServer(currentValue.fechaValidez);
        });

        this.infoIdentidades = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(info)
  {
    if (info.id != 0)
    {
      this.obtenerHistorial(info);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.infoIdentidad = info;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.infoIdentidad))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.infoIdentidadService.eliminar(this.infoIdentidad.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let infoIdentidad = this.infoIdentidadesList.filter(d => d.id != this.infoIdentidad.id)[0];
              if (infoIdentidad == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(infoIdentidad);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.infoIdentidad))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.infoIdentidadDetalle.form.controls['desde'].disable();
        $this.infoIdentidadDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let info = this.infoIdentidadesList.find(d => d.id == index);
    this.infoIdentidad = info;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.infoIdentidadDetalle.setearForm(this.infoIdentidad);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.infoIdentidadDetalle.form.getRawValue();

      let datosInfo: InfoIdentidad = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseDocumento: formulario.claseDocumento,
        docNro: formulario.docNro,
        fechaEmision: this.momentService.saveDateServer(formulario.fechaEmision, false),
        fechaValidez: this.momentService.saveDateServer(formulario.fechaValidez, false),
        lugarEmision: formulario.lugarEmision,
        nroEmision: formulario.nroEmision,
        paisEmisor: formulario.paisEmisor,
        autoridad: formulario.autoridad
      };

      this.infoIdentidadService.guardar(datosInfo, this.cortarRegistro).subscribe(
        infoI =>
        {
          infoI.desde = this.momentService.convertDateServer(infoI.desde);
          infoI.hasta = this.momentService.convertDateServer(infoI.hasta);
          infoI.fechaEmision = this.momentService.convertDateServer(infoI.fechaEmision);
          infoI.fechaValidez = this.momentService.convertDateServer(infoI.fechaValidez);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Info Identidad guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(infoI);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          this.infoIdentidadDetalle.setearForm(infoI);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.infoIdentidadDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.infoIdentidadDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.infoIdentidadHistoryList = [];
    this.infoIdentidadesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerIdentidades(false);
  }

  private obtenerHistorial(infoIdentidad: InfoIdentidad)
  {
    this.infoIdentidadService.getHistoryByClase(infoIdentidad.personal, infoIdentidad.claseDocumento).subscribe(
      infos =>
      {
        infos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechaEmision = this.momentService.convertDateServer(currentValue.fechaEmision);
          currentValue.fechaValidez = this.momentService.convertDateServer(currentValue.fechaValidez);
        });

        this.infoIdentidadHistoryList = [];
        infos.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.infoIdentidadHistoryList.push(item);
        });

        this.infoIdentidadesList = infos;
        this.verDetalle = true;
        this.infoIdentidad = infoIdentidad;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.infoIdentidadDetalle.form.get("desde").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.infoIdentidadDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } 

    if (this.infoIdentidadDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.infoIdentidadDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    return edita;
  }
}
